import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface IWarehouseDetail {
    id: string,
    code: string,
    name: string,
    shopId?: string,
    shopCode?: string,
    shopName?: string,
    branch?: string,
    ver?: string,
    enable?: string,
    orgCode?: string,
    orgName?: string,
    contact?: string,
    phone?: string,
    address?: string,
    status?: number | boolean,
    note?: string,
    orderNum?: string,
    //createTime?: string,
    createUser?: string,
    updateUser?: string,
    deleteFlag?: string,
    sourceApp?: string,
    categoryName?:string,
    typeCode?:string,
    typeName?:string,
    createTime?:moment.Moment | null | string;
	updateTime?:moment.Moment | null | string;
}
//新增
export interface IWarehouseInsert extends IWarehouseDetail {

}

//编辑
export interface IWarehouseUpdate extends IWarehouseInsert {
    id: string,
}

//搜索条件
export interface IWarehouseSearchFields {

}

export interface IWarehouseSearch
    extends IWarehouseSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}


/**
 * 仓库 货位信息
 */
export interface IpositionDetail {
    id: string,
    warehouseCode: string,
    warehouseId: string,
    orgId?: string,
    orgName?: string,
    warehouseName?: string,
    areaId?: string,
    areaCode?: string,
    areaName?: string,
    shelvesId?: string,
    shelvesCode?: string,
    shelvesName?: string,
    positionName?: string,
    positionDesc?: string,
    positionCode?: string,
    code?: string,
    shopId?: string,
    shopName?: string,
}

export interface IpositionInsert extends IpositionDetail {

}

//货位批量录入
export interface IpositionBatchInsert extends IpositionInsert {
    prefix: string,
    startCode: string,
    num: string,
}
export interface IPositionUpdate extends IpositionInsert {
    id: string,
}

export interface IpositionSearchFields {
    areaId?: string,
    shelvesId?: string,
    code?: string
    warehouseId?: string
    warehouseCode?: string
}
export interface IpositionSearch
    extends IpositionSearchFields, ISearchPage {
}

//货架表单字段
export interface IPositionFormFields {
    warehouseName: string,
    code: string,
    areaId: string,
    areaCode: string,
    shelvesId: string,
    shelvesCode: string,
    note?: string,
    isBatch: boolean,
    startCode: string,
    num: string,
    prefix: string,
    id: string
}


class WarehouseService {
    async page(searchVo: IWarehouseSearch, config: object = {}) {
        const apiUrl = "/gtm/base/warehouse/listPage";
        return await httpRequest.post<IPage<IWarehouseDetail>>(apiUrl, searchVo, config);
    }
    async one(id: string) {
        const apiUrl = `/gtm/base/warehouse/findById/${id}`;
        return await httpRequest.get<IWarehouseDetail>(apiUrl);
    }
    async insert(insertVo: IWarehouseInsert) {
        const apiUrl = "/gtm/base/warehouse/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IWarehouseUpdate) {
        const apiUrl = "/gtm/base/warehouse/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    // //启用禁用
    // async disable(id: string, status: number) {
    //     const apiUrl = `/gtm/base/warehouse/enableOrDisable/${id}/${status}`;
    //     return await httpRequest.get<boolean>(apiUrl);
    // }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/gtm/base/warehouse/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IWarehouseSearch) {
        const appPageUrl = "/gtm/base/warehouse/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/base/warehouse/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }


    async positionPage(searchVo: IpositionSearch) {
        const apiUrl = "/gtm/base/warehouse/shelf/listPage";
        return await httpRequest.post<IPage<IpositionDetail>>(apiUrl, searchVo);
    }
    async positionInsert(insertVo: IpositionInsert) {
        const apiUrl = "/gtm/base/warehouse/shelf/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //批量新增货位
    async positionBatchInsert(insertVo: IpositionBatchInsert) {
        const apiUrl = "/gtm/base/warehouse/shelf/batchInsert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async positionUpdate(updateVo: IPositionUpdate) {
        const apiUrl = "/gtm/base/warehouse/shelf/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //货位模板下载
    async positionDownloadTpl() {
        const appPageUrl = "/gtm/base/warehouse/shelf/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
    //货位导出
    async positionExport(whId: string) {
        const appPageUrl = `/gtm/base/warehouse/shelf/export/${whId}`;
        return await httpRequest.getFile(appPageUrl);
    }
}

export const warehouseService = new WarehouseService();
